import contractsReducer from '../components/Contracts/ContractsReducers'
import apiClientReducer from './ApiClient/ApiClientReducer'
import flashMessageReducer from '../components/FlashMessage/FlashMessageReducers'
import appReducer from '../components/App/AppReducers'
import { combineReducers, createStore } from 'redux'

const allReducers = combineReducers({
    contracts: contractsReducer,
    apiClient: apiClientReducer,
    flashMessage: flashMessageReducer,
    app: appReducer
})

export const store = createStore(allReducers)


// WEBPACK FOOTER //
// ./src/common/Store.js